import * as React from "react";
import './magazine-widget.css';
import {LoaderSpinner} from "./LoaderSpinner";
import {MagazineArticle} from "./magazine/MagazineArticle";
import {ErlButtonBigRed} from "./ErlButtonBigRed";
import {Article} from "../model/Article";
import {AppContext} from "../context/AppContext";
import {ApiResponse} from "../../shared/models/ApiResponse";

interface MagazineWidgetProps {
    type: string,
    showHeader: boolean,
    articles: string,
    numberOfArticles: number
}

interface MagazineWidgetState {
    articles: Article[],
    loading: boolean,
}

/**
 * Text Input Element
 */
export class MagazineWidget extends React.Component<MagazineWidgetProps, MagazineWidgetState> {

    state: MagazineWidgetState = {
        articles: [],
        loading: true,
    };

    apiHeaders: any = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    componentDidMount() {
        this.loadArticles();
    }

    /**
     * load articles.
     */
    loadArticles() {
        const articleIds: string[] = this.props.articles.split(",");
        const articleIncIds: number[] = [];
        articleIds.map(value => {
            !isNaN(parseInt(value, 10)) && articleIncIds.push(parseInt(value, 10));
        });

        AppContext.magazineService.getArticles(articleIncIds, this.props.type == 'single' ? 1 : this.props.numberOfArticles).then((resp: ApiResponse) => {
            this.setState({loading: false});
            if (resp.success) {
                this.setState({articles: resp.response.articles});
            }
        });
    }

    /**
     * nav to erl magazine.
     */
    goToMagazine() {
        window.open('https://magazin.erl.de', '_blank');
    }

    render() {
        return <div className="magazine-widget">

            {this.props.showHeader &&
            <nav onClick={this.goToMagazine}>
                <img alt="ERL Magazin" src="/wp-content/plugins/erlbau/images/magazin.png"/>
                {this.props.type === 'multi' && (
                    <ErlButtonBigRed label="Alle Artikel anzeigen"/>
                )}
            </nav>
            }

            {this.state.loading &&
            <LoaderSpinner/>
            }

            {!this.state.loading &&
            <div className={this.props.type == 'single' ? 'magazine-single' : 'magazine-multi'}>
                {this.state.articles.map((article: Article) => {
                    return <MagazineArticle key={article.id} article={article}/>
                })}
            </div>
            }
        </div>
    }
}
